import { createSelector } from "@reduxjs/toolkit";

import { selectScoringState } from "../selectors";

const selectEditAnalysisState = createSelector(
  [selectScoringState],
  (scoring) => scoring.edit
);

export const selectFocusedParagraphId = createSelector(
  [selectEditAnalysisState],
  (edit) => edit.focusedParagraphId ?? null
);

export const selectDeletedParagraphIds = createSelector(
  [selectEditAnalysisState],
  (edit) => edit.deletedParagraphIds ?? []
);

export const selectEditedParagraphIds = createSelector(
  [selectEditAnalysisState],
  (edit) => edit.editedParagraphIds ?? []
);

export const selectCompletedParagraphIds = createSelector(
  [selectEditAnalysisState],
  (edit) => edit.completedParagraphIds ?? []
);

export const selectEditedParagraphCurrentTexts = createSelector(
  [selectEditAnalysisState],
  (edit) => edit.editedParagraphCurrentTexts ?? {}
);

export const selectIssueIdsFilter = createSelector(
  [selectEditAnalysisState],
  (edit) => edit.issueIdsFilter ?? []
);
